import script from "./VrpNotificationQueuePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./VrpNotificationQueuePopup.vue?vue&type=script&setup=true&lang=js"

import "./VrpNotificationQueuePopup.vue?vue&type=style&index=0&id=7c64b876&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c64b876"]])

export default __exports__